class MobileToolbar extends HTMLElement {
  constructor() {
    super();

    this.onVehicleSearchClick = this.toggleVehicleSearch.bind(this);
    this.onFiltersClick = this.toggleFilters.bind(this);

    this.btnVehicleSearch = this.querySelector(".js-btn-vehicle");
    if (this.btnVehicleSearch) {
      this.btnVehicleSearch.addEventListener(
        "click",
        this.onVehicleSearchClick
      );
      this.btnCloseVehicleSearch = document.querySelector(
        ".js-btn-close-vehicle"
      );
      this.btnCloseVehicleSearch.addEventListener(
        "click",
        this.onVehicleSearchClick
      );
    }

    this.btnFilters = this.querySelector(".js-btn-filters");
    if (this.btnFilters) {
      this.btnFilters.addEventListener("click", this.onFiltersClick);
      this.btnFilters = document.querySelector(".js-btn-close-filters");
      this.btnFilters.addEventListener("click", this.onFiltersClick);
    }
  }

  toggleVehicleSearch() {
    const vehicleSearchContainer = document.querySelector(
      ".vehicle-search-container"
    );
    vehicleSearchContainer.classList.toggle("show");
  }

  toggleFilters() {
    const filtersContainer = document.querySelector(".filters-container");
    filtersContainer.classList.toggle("show");
  }
}

customElements.define("mobile-toolbar", MobileToolbar);
